// SPDX-FileCopyrightText: Szilárd Hajba
// SPDX-License-Identifier: LGPL-3.0-or-later
import * as React from 'react';
import { formatTimeRange } from '../utils/dates.js';
export function MonthEvent({ event, startCol, span, lane, continuesLeft, continuesRight, selected, locale, onSelect }) {
    const cls = [
        'c-cal-month-event',
        event.allDay ? 'is-allday' : '',
        event.recurring ? 'is-recurring' : '',
        event.hasOverride ? 'has-override' : '',
        event.ghost ? 'is-ghost' : '',
        selected ? 'is-selected' : '',
        continuesLeft ? 'continues-left' : '',
        continuesRight ? 'continues-right' : ''
    ]
        .filter(Boolean)
        .join(' ');
    // Ghost markers get their muted palette from the stylesheet — skip the
    // inline background/color so the .is-ghost rules can win without !important.
    const style = event.ghost
        ? {
            gridColumn: `${startCol} / span ${span}`,
            gridRow: `${lane + 2}` // row 1 is the date number; events start at 2
        }
        : {
            gridColumn: `${startCol} / span ${span}`,
            gridRow: `${lane + 2}`,
            background: event.color || 'var(--col-primary)',
            color: event.textColor || 'var(--col-on-primary)'
        };
    const timeLabel = event.allDay ? '' : formatTimeRange(event.start, event.end, locale);
    return (React.createElement("button", { type: "button", className: cls, style: style, onClick: event.ghost ? undefined : () => onSelect?.(event.id), "aria-disabled": event.ghost || undefined, tabIndex: event.ghost ? -1 : undefined, "data-event-id": event.id },
        timeLabel && React.createElement("span", { className: "c-cal-month-event__time" }, timeLabel),
        React.createElement("span", { className: "c-cal-month-event__title" }, event.title || '(untitled)')));
}
// vim: ts=4
